import React from "react";

const LoanEligibility = () => {
  return <div>LoanEligibility</div>;
};

export default LoanEligibility;
